import 'reflect-metadata';
import {Container} from 'inversify';
import {httpApi} from '../../common/infra/http';
import { CreateUseCase } from '../application/create.use.case';
import { InvoiceHttpGateway } from './invoice.http.gateway';

export const Registry = {
    AxiosAdapter: Symbol.for('AxiosAdapter'),
    InvoiceGateway: Symbol.for('InvoiceGateway'),
    CreateUseCase: Symbol.for('CreateUseCase'),
};

export const container = new Container();

//########## HTTP
container.bind(Registry.AxiosAdapter).toConstantValue(httpApi);

//#region ########## GATEWAYS
container.bind(Registry.InvoiceGateway).toDynamicValue((context) => {
    return new InvoiceHttpGateway(context.container.get(Registry.AxiosAdapter));
});

//#endregion

//#region ########## USE CASES
container.bind(Registry.CreateUseCase).toDynamicValue((context) => {
    return new CreateUseCase(context.container.get(Registry.InvoiceGateway));
});
//#endregion

//#region ######### CONTAINERS GET
const invoice = {
    create: container.get<CreateUseCase>(Registry.CreateUseCase)
};
export default invoice;
//#endregion
